import React from 'react'

import Section from 'component/Section'
import SectionHeader from 'component/SectionHeader'
import SectionSplit from 'component/SectionSplit'
import SectionSplitWrapper from 'component/SectionSplitWrapper'
import ProductFeatures from 'component/ProductFeatures'
import { StaticImageContainer } from 'component/StaticImageContainer'

import { StaticImage } from 'gatsby-plugin-image'

import IconComputerCloud from 'svg/icons/computer-cloud.svg'
import IconFileUp from 'svg/icons/file-up.svg'
import LogoAstreaHorizontal from 'svg/logos/astrea-horizontal.svg'
import IconCalendar from 'svg/icons/calendar.svg'
import IconFolderCheck from 'svg/icons/folder-check.svg'

const AstreaSection = () => {
	return (
		<Section theme="astrea">
			<SectionHeader
				titleIcon={
					<h2>
						<LogoAstreaHorizontal />
					</h2>
				}
				subTitle="O melhor software jurídico para escritórios de advocacia e advogados autônomos"
			/>
			<SectionSplitWrapper>
				<SectionSplit size={'40'}>
					<ProductFeatures
						id={'astrea'}
						imgsrc={'/a'}
						imgalt={'a'}
						buttons={[
							{
								id: 'astrea',
								text: 'Conheça tudo sobre o Astrea',
								link: '/astrea/',
							},
						]}
						list={[
							{
								id: '1',
								icon: <IconFolderCheck />,
								title: 'Gestão jurídica completa',
								description: `O Astrea aperfeiçoa sua gestão jurídica desde o primeiro atendimento até o encerramento do processo! Com o Astrea você substitui as anotações da agenda, os registros nas planilhas e as pastas no computador por um software jurídico com inteligência artificial, completo e fácil de usar.`,
							},
							{
								id: '2',
								icon: <IconComputerCloud />,
								title: 'Processos atualizados diariamente',
								description: `Faça a primeira carga de processos em tempo recorde! Os robôs do Astrea rastreiam os sites dos tribunais e levam os processos do seu escritório para dentro do sistema automaticamente. Com os processos cadastrados, você passa a receber todas as atualizações de forma automática. O software também envia alertas para garantir que você não perca nenhuma movimentação!`,
							},
							{
								id: '3',
								icon: <IconFileUp />,
								title: (
									<>
										Publicações&nbsp;
										<br className="mobile" />
										diretamente no sistema
									</>
								),
								description: `Com a tecnologia avançada do Astrea, você não precisa perder horas separando publicações de homônimos. Você recebe, de forma automática, apenas as publicações dos Diários Oficiais que realmente deseja! Além disso, o software oferece o ambiente ideal para tratar os prazos e dar os devidos encaminhamentos aos processos.`,
							},
							{
								id: '4',
								icon: <IconCalendar />,
								title: (
									<>
										Controle avançado&nbsp;
										<br className="mobile" />
										de prazos processuais
									</>
								),
								description: `O controle avançado do Astrea permite que você gerencie os prazos do seu escritório do início ao fim! De forma integrada, você pode delegar tarefas com facilidade e garantir que todos os envolvidos cumpram suas atividades a tempo.`,
							},
						]}
					/>
				</SectionSplit>
				<SectionSplit size={'60'} className="desktop">
					<StaticImageContainer isOverflowVisible={true}>
						<StaticImage
							src="../../../media-library/illustrations/astrea-lawsuit-detail.png"
							alt="Interface do software jurídico Astrea"
							width={945}
							height={570}
							placeholder="blurred"
							formats={['AUTO', 'WEBP', 'AVIF']}
						/>
					</StaticImageContainer>
				</SectionSplit>
			</SectionSplitWrapper>
		</Section>
	)
}

export default AstreaSection
